module.exports = __webpack_public_path__ + "img/3042c03.png";